import { Link } from "react-router-dom";
import { Mail, MapPin, Send, Clock, Megaphone } from "lucide-react";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import { useSettings } from "@/context/SettingsContext";

export default function Contacts() {
  const settings = useSettings();
  return (
    <Layout showTicker={false}>
      <Seo
        title="Контакти"
        description="Свържете се с редакцията на „Подуяне Днес“ — имейл, локация и форма за сигнали."
      />
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8" data-testid="contacts-page">
        <span className="inline-flex rounded-full bg-primary/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-primary">
          Контакти
        </span>
        <h1 className="mt-4 font-display text-4xl font-extrabold text-slate-900">
          Свържете се с нас
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-slate-600">
          Имате въпрос, предложение или новина? Пишете ни — четем всяко
          съобщение.
        </p>

        <div className="mt-10 grid gap-6 sm:grid-cols-2">
          <div className="rounded-xl border border-slate-200 bg-white p-6">
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10">
              <Mail className="h-6 w-6 text-primary" />
            </div>
            <h3 className="mt-4 font-display text-lg font-bold text-slate-900">Имейл</h3>
            <p className="mt-1 text-slate-600">{settings.contact_email}</p>
          </div>

          <div className="rounded-xl border border-slate-200 bg-white p-6">
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10">
              <MapPin className="h-6 w-6 text-primary" />
            </div>
            <h3 className="mt-4 font-display text-lg font-bold text-slate-900">Локация</h3>
            <p className="mt-1 text-slate-600">район Подуяне, гр. София</p>
          </div>

          <div className="rounded-xl border border-slate-200 bg-white p-6">
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10">
              <Clock className="h-6 w-6 text-primary" />
            </div>
            <h3 className="mt-4 font-display text-lg font-bold text-slate-900">Работно време</h3>
            <p className="mt-1 text-slate-600">Понеделник – Петък, 9:00 – 18:00</p>
          </div>

          <div className="rounded-xl border border-primary/20 bg-primary/5 p-6">
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/15">
              <Megaphone className="h-6 w-6 text-primary" />
            </div>
            <h3 className="mt-4 font-display text-lg font-bold text-slate-900">
              Подайте сигнал
            </h3>
            <p className="mt-1 text-slate-600">
              За най-бърза реакция използвайте формата за сигнали.
            </p>
            <Link
              to="/izprati-signal"
              className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:underline"
            >
              <Send className="h-4 w-4" />
              Към формата
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
